import React, { useEffect } from "react";
import classes from "./OrderProcessing.module.scss";
import Main from "../components/OrderProcessing/Main";
import { getUserRole } from "../reducks/users/selectors";
import { useDispatch, useSelector } from "react-redux";
import { PERMISSIONS } from "../constants/permissions";
import { push } from "connected-react-router";
const OrderProcessing = () => {
  const userRole = useSelector(getUserRole);
  const dispatch = useDispatch();
  const isUpperNormal =
    userRole === PERMISSIONS.ADMINISTRATOR ||
    userRole === PERMISSIONS.HUMAN_RESOURCE_USER ||
    userRole === PERMISSIONS.ORDER_USER;

  useEffect(() => {
    if (isUpperNormal === false) {
      dispatch(push("/"));
    }
  }, [userRole, dispatch, isUpperNormal]);
  return (
    <div className={classes.root}>
      <Main />
    </div>
  );
};

export default OrderProcessing;
